<template>
    <div>

        <edit-staff-contact-dialog
            v-model="show_staff_contact_dialog"
            :modelProp="selected_staff_contact"
            @successful-save="refreshStaffContactsData"
            @successful-delete="refreshStaffContactsData"
            :constants="constants"
        />

        <div class="tw-flex tw-flex-col tw-gap-4 tw-p-1">

                <internal-table-section section-title="Staff Contacts" button-text="Add Staff" @button-clicked="addStaffContactItem" class="tw-w-full">
                    <v-card id="table_about_us_card" class="d-flex flex-row container-fluid" flat>
                        <v-card-text class="pa-0 d-block">
                            <div class="px-7">
                                <v-layout child-flex>
                                    <smart-table
                                        id="table_staff_contacts"
                                        class="row-pointer"
                                        endpoint="staffcontacts.list"
                                        :headers="headers_staff_contacts"
                                        flat
                                        @click:row="showStaffContactItem"
                                        ref="staff_contacts_list"
                                    >
                                    </smart-table>
                                </v-layout>
                            </div>
                        </v-card-text>
                    </v-card>
                </internal-table-section>

        </div>
    </div>

</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import InternalHeader from "@/Generic/InternalHeader";
    import InternalTableSection from "@/Generic/InternalTableSection";
    import EditStaffContactDialog from "@/Modals/EditStaffContactDialog.vue";

    export default {
        name: "WebsiteContentContactUs",
        components: {
            EditStaffContactDialog,
            SmartTable,
            InternalHeader,
            InternalTableSection,
        },
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                selected_staff_contact: null,
                show_staff_contact_dialog: false,
            }
        },
        mounted() {
            //
        },
        computed: {
            headers_staff_contacts() {
                return [
                    {value: 'priority',     text: 'Priority',       align: `start`,     sortable: false,   filterable: false,   search: null, optional: false },
                    {value: 'name',         text: 'Name',           align: `start`,     sortable: false,   filterable: false,   search: null, optional: false },
                    {value: 'role',         text: 'Role',           align: `start`,     sortable: false,   filterable: false,   search: null, optional: false },
                    {value: 'email',        text: 'Email',          align: `start`,     sortable: false,   filterable: false,   search: null, optional: false },
                    {value: 'phone',        text: 'Phone',          align: `start`,     sortable: false,   filterable: false,   search: null, optional: false },
                    {value: 'description',  text: 'Description',    align: ` d-none`,   sortable: false,   filterable: false,   search: null, optional: false },
                ]
            },
        },
        methods: {
            // History
            refreshStaffContactsData() {
                this.$refs.staff_contacts_list.refreshList()
            },
            showStaffContactItem(item) {
                this.selected_staff_contact = item
                this.show_staff_contact_dialog = true
            },
            addStaffContactItem() {
                this.selected_staff_contact = null
                this.show_staff_contact_dialog = true
            },
        }
    }
</script>
